module.exports = __webpack_public_path__ + "static/media/gameJigsawPuzzle5x5.bf5196c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameJigsawPuzzle5x5.png
// module id = 2460
// module chunks = 0